var React = require('react');

function Mountain (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .a0dfcf48-c8d9-4ca2-8215-b81be5641548 {\n        fill: #19324D;\n      }\n    ")),React.createElement("path",{"id":"b416cc64-9bd5-4a05-a9bb-7802247d83c9","data-name":"Path 2432","className":"a0dfcf48-c8d9-4ca2-8215-b81be5641548","d":"M0,183.236,108.276,49.974l43.031,44.421L216.552,0l87.454,116.6,41.645-38.868,93.006,105.5Z","key":1})]);
}

Mountain.defaultProps = {"id":"ebe8a28d-b943-49af-ba95-607297237a9f","data-name":"Layer 1","viewBox":"0 0 438.65696 183.23599"};

module.exports = Mountain;

Mountain.default = Mountain;
